import axios, {AxiosInstance} from 'axios';
import {BaseModel} from '../models/BaseModel';
import {Utility} from '../core/Utility';
import {GlobalActionTypes} from "../store/global";
import {AppStore} from "../desktop";
import {LoggerService} from "../core/logger/LoggerService";
import {AppCookies} from "../core/Cookies";
import {AppConfig} from "../config";

export abstract class API<T extends BaseModel> {

	endpoint: string;
	protected static axiosInstance: AxiosInstance;

	constructor (endpoint: string) {
		this.endpoint = endpoint;
		API.initAxios();
	}

	public static initAxios () {
		if (API.axiosInstance == null) {
			API.axiosInstance = axios.create({
				baseURL: AppConfig().api.baseUrl,
				timeout: AppConfig().api.timeout,
				//headers: {'X-Custom-Header': 'foobar'},
				responseType: 'json'
			});
			API.axiosInstance.interceptors.request.use((request) => {
				console.log("Axios request");
				AppStore.dispatch({type: GlobalActionTypes.START_LOADING})
				let accessToken = AppCookies.getAccessToken()
				request.headers.Authorization = 'Bearer ' + accessToken // todo: receck if cookie storing is safe enough.
				return request;
			});
			API.axiosInstance.interceptors.response.use((response) => {
				console.log("Axios response");
				AppStore.dispatch({type: GlobalActionTypes.END_LOADING})
				return response;
			}, (error) => {
				AppStore.dispatch({type: GlobalActionTypes.END_LOADING})
				console.log("Axios error response");
				return error;
			});
		}
	}

	public getAll (): Promise<any> {
		let url = `/${this.endpoint}`;
		return API.axiosInstance.get(url);
	}

	public getAllForIndexing (): Promise<any> {
		let url = `/${this.endpoint}/indexing`;
		return API.axiosInstance.get(url);
	}

	public getAllIndexed (): Promise<any> {
		let url = `/${this.endpoint}/indexed`;
		return API.axiosInstance.get(url);
	}

	public get (item: T): Promise<any> {
		let url = `/${this.endpoint}/${item.id}`;
		return API.axiosInstance.get(url);
	}

	public post (item: T): Promise<any> {
		let url = `/${this.endpoint}`;
		let payload = item;
		return API.axiosInstance.post(url, payload);
	}

	public put (item: T): Promise<any> {
		if (Utility.isNullOrUndefined(item.id)) LoggerService.addError("Id not defined");
		let url = `/${this.endpoint}/${item.id}`;
		let payload = item;
		return API.axiosInstance.put(url, payload);
	}

	public patch (item: T): Promise<any> {
		if (Utility.isNullOrUndefined(item.id)) LoggerService.addError("Id not defined");
		let url = `/${this.endpoint}/${item.id}`;
		let payload = item;
		return API.axiosInstance.patch(url, payload);
	}

	public delete (item: T): Promise<any> {
		if (Utility.isNullOrUndefined(item.id)) LoggerService.addError("Id not defined");
		let url = `/${this.endpoint}/${item.id}`;
		return API.axiosInstance.delete(url);
	}
}
